import GATSBY_COMPILED_MDX from "/home/develop/pxplanding/data/landings/customerfeedback-1-contact.mdx";
import React from "react";
import {Content} from "../../../components/container/container";
import SEO from "../../../components/seo";
import Header from "../../../components/new-components/Header/Header";
import * as styles from "./landing.module.css";
import HeaderBlurSVG from "../../../images/backgroundBlur/blur-header-landing.inline.svg";
import FooterDetails from "../../../components/new-components/Footer/FooterDetails/FooterDetails";
const LandingTemplate = _ref => {
  let {children} = _ref;
  return React.createElement("div", {
    className: styles.container
  }, React.createElement("div", {
    className: styles.headerBlurSvg
  }, React.createElement(HeaderBlurSVG, null)), React.createElement(Header, null), React.createElement(Content, {
    className: styles.mainContent
  }, children), React.createElement(FooterDetails, {
    name: "Landing",
    slug: "/landing",
    section: "Landing"
  }));
};
LandingTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(LandingTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
const query = "1856353193";
export const Head = _ref2 => {
  var _data$landingsJson, _data$landingsJson$co, _content$frontmatter, _content$frontmatter$;
  let {data} = _ref2;
  const content = (_data$landingsJson = data.landingsJson) === null || _data$landingsJson === void 0 ? void 0 : (_data$landingsJson$co = _data$landingsJson.content) === null || _data$landingsJson$co === void 0 ? void 0 : _data$landingsJson$co.childMdx;
  const keywords = (content === null || content === void 0 ? void 0 : (_content$frontmatter = content.frontmatter) === null || _content$frontmatter === void 0 ? void 0 : _content$frontmatter.keywords) || [];
  return React.createElement(SEO, {
    title: content.frontmatter.title,
    meta: [{
      name: "keywords",
      content: keywords.join(",")
    }],
    description: content === null || content === void 0 ? void 0 : content.frontmatter.description,
    image: content === null || content === void 0 ? void 0 : (_content$frontmatter$ = content.frontmatter.image) === null || _content$frontmatter$ === void 0 ? void 0 : _content$frontmatter$.publicURL
  });
};
